<script setup>
import { computed, getCurrentInstance } from 'vue';
import Button from "../Button.vue";

const { proxy } = getCurrentInstance();
const store = proxy.$store;
const router = proxy.$router;

// --- Computed ---

const activeEditId = computed(() => store.state.componentFields.activeEditId);

const isContentTypeComponent = computed(() => {
    return store.getters['componentFields/isContentType'];
});

// --- Methods ---

const doShowAddFieldForm = () => {
    // Relates to when editing a content type's fields in Themes -> Content types
    if (isContentTypeComponent.value) {
        store.commit('componentFields/activeEditId', 0);
    } else {
        router.push({
            name: 'componentFields',
            params: {
                fieldsetId: store.state.componentFields.activeFieldsetId || 0,
                fieldId: 0
            }
        });
    }
};
</script>

<template>
    <Button
        class="border"
        title="Add a field"
        @click.native="doShowAddFieldForm"
        :active-class="'btn-primary'"
        :active-value="activeEditId === 0"
    >
        <i class="bi bi-plus-lg"/>
        Field
    </Button>
</template>